// extracted by mini-css-extract-plugin
export var body = "padlock-module--body--HyazA";
export var icon = "padlock-module--icon--29nOM";
export var iconHost = "padlock-module--iconHost--skft8";
export var keyhole = "padlock-module--keyhole--5zNcR";
export var locked = "padlock-module--locked---D0X8";
export var padlock = "padlock-module--padlock--EiOX0";
export var shackle = "padlock-module--shackle--25nRI";
export var unlocked = "padlock-module--unlocked--YSzdz";